import { render, staticRenderFns } from "./ProjectVerboseAbbreviationWidget.vue?vue&type=template&id=12463372&"
import script from "./ProjectVerboseAbbreviationWidget.vue?vue&type=script&lang=ts&"
export * from "./ProjectVerboseAbbreviationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports